import styled from 'styled-components';
const CheckoutContainer = styled.div`
    padding: 80px 0;
`
export {CheckoutContainer};